import classNames from 'classnames';
import React from 'react';
import {AnyToDo} from '../../../../typings/todo';
import {SVGIcon} from '../../ui/SVGIcon/SVGIcon';
import styles from './BarButton.scss';
import {ButtonProps, SvgComponent} from '../../../reactDomTypes';

interface Props extends ButtonProps {
  SvgIcon: SvgComponent;
  accName?: string;
  dataHook?: string;
  className?: string;
}

export const BarButton: React.FC<Props> = ({SvgIcon, accName, dataHook, className: outerClassName, ...otherProps}) => {
  const icon = SvgIcon ? <SVGIcon Svg={SvgIcon} /> : null;
  const className = classNames(outerClassName, styles.barButton);

  return (
    <button type="button" className={className} aria-label={accName} data-hook={dataHook} {...otherProps}>
      {icon}
    </button>
  );
};
